export const getCustomProperties = (inlineStyles: { [propertyName: string]: string }) =>
  Object.entries(inlineStyles)
    .map(([key, value]) => `${key}: ${value}`)
    .join(';');

export const withAlpha = (hex: string, opacity: number) => `${hex}${Math.floor(opacity * 255).toString(16)}`;
